import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import store_fiche from "@/store/mods/consultations/fiche-consultations"
import ManageSection from '@/views/parametres/configs/param-fiche-medical/manage-section'
import ManageFicheChamp from '@/views/parametres/configs/param-fiche-medical/manage-fiche-champ'
import  $ from 'jquery'

export default {
    name: 'liste-sections-champs',
    components: {
        ManageSection, ManageFicheChamp
    },
    props: {
        selected_consultation: Object,
        selected_fiche: Object,
        selected_section: Object,
        info_user: Object,
        activeRole: Object
    },
    data() {
        return {
            vm_state: open_menu_state,
            liste_champs: [],
            liste_champ_empty: false,
            liste_champ_loading: true,

            fields: [
				'champ', { key: 'type_champ', label: 'Type de champ' }, 'occurences', 'statut',
                { key: 'actions', label: 'Action.s' }
			],
			filter_champ: "",
			perPage: -1,
			currentPage: 1,

            edit_modal_toggler: 0,
            section_to_edit: {},
            liste_sections: [],
            default_consultation_sections: [],
            liste_autre_consultations: [],
            champ_to_edit: {},
            is_champ_ordering: 1,
            m_toggler: 0
        }
    },

    computed: {

    },

    mounted() {
        const ts = this;
        $(document).bind("click", function (e) {
            const $clicked = $(e.target);
            if (!$clicked.parents().hasClass("drp-container")) {
                if (ts.vm_state != 0) {
                    ts.openMenu(ts.vm_state, 'drp-menu', 'animate-zoomIn', 'animate-zoomOut')
                }
            }
        });

        this.getListeChamps()

        this.section_to_edit = this.selected_section
    },

    methods: {
         /**
         * Open Menu Dropdown
         */
         async openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        goToPage(goto_page) {
            this.$emit('emitGoToPage', goto_page)
        },

        getListeChamps() {
            this.liste_champ_loading = true
            const data = {
                fcs_id: this.selected_section.fcs_id
            }
            store_fiche.geListeChampByFicheSection(data).then((response) => {
                this.liste_champs = response

                if (this.liste_champs.length == 0) {
                    this.liste_champ_empty = true
                } else {
                    this.liste_champ_empty = false
                }
                this.liste_champ_loading = false
            })
        },

        setChampToEdit(data) {
            this.edit_modal_toggler = (this.edit_modal_toggler == 0)?1:0
            this.champ_to_edit = data

            $('.add-fiche-section').modal('show')
        },

        addNewField() {
            this.champ_to_edit = {}
            this.edit_modal_toggler = (this.edit_modal_toggler == 0)?1:0
            $('.add-fiche-section').modal('show')
        },

        orderChamp() {
            this.edit_modal_toggler = (this.edit_modal_toggler == 0)?1:0
            $('.order-evolution').modal('show')
        },

        manageChamp() {
            this.m_toggler = (this.m_toggler == 0)?1:0

            $('.ges-champs').modal('show')
        }
    }
}